import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig, withInMemoryScrolling  } from '@angular/router';
import { routes } from './app.routes';
import { LoggingInterceptor } from './core/interceptors/logging.interceptor';
import { CarouselMonitorInterceptor } from './core/interceptors/carousel-monitor.interceptor';
import { DiscountsMonitorInterceptor } from './core/interceptors/discounts-monitor.interceptor';
import { EmergencyRateLimitInterceptor } from './core/interceptors/emergency-rate-limit.interceptor';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { GlobalExceptionFilter } from './core/exception-filter/global-error-handler';
import { UserService } from './core/services/user/user.service';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

// Agregar los iconos a la biblioteca
library.add(faPhone, faWhatsapp);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes
      ,
   withInMemoryScrolling({  // Mueve las opciones de scroll aquí
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      })
    ),
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoggingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CarouselMonitorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DiscountsMonitorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EmergencyRateLimitInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalExceptionFilter
    },
    UserService,
    provideClientHydration(),
    provideAnimations(),
    FontAwesomeModule
  ],
};
